// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  ABW: (t, data?, options?) => t('enum.country.abw.name', data, options),
  AFG: (t, data?, options?) => t('enum.country.afg.name', data, options),
  AGO: (t, data?, options?) => t('enum.country.ago.name', data, options),
  AIA: (t, data?, options?) => t('enum.country.aia.name', data, options),
  ALA: (t, data?, options?) => t('enum.country.ala.name', data, options),
  ALB: (t, data?, options?) => t('enum.country.alb.name', data, options),
  AND: (t, data?, options?) => t('enum.country.and.name', data, options),
  ARE: (t, data?, options?) => t('enum.country.are.name', data, options),
  ARG: (t, data?, options?) => t('enum.country.arg.name', data, options),
  ARM: (t, data?, options?) => t('enum.country.arm.name', data, options),
  ASM: (t, data?, options?) => t('enum.country.asm.name', data, options),
  ATA: (t, data?, options?) => t('enum.country.ata.name', data, options),
  ATF: (t, data?, options?) => t('enum.country.atf.name', data, options),
  ATG: (t, data?, options?) => t('enum.country.atg.name', data, options),
  AUS: (t, data?, options?) => t('enum.country.aus.name', data, options),
  AUT: (t, data?, options?) => t('enum.country.aut.name', data, options),
  AZE: (t, data?, options?) => t('enum.country.aze.name', data, options),
  BDI: (t, data?, options?) => t('enum.country.bdi.name', data, options),
  BEL: (t, data?, options?) => t('enum.country.bel.name', data, options),
  BEN: (t, data?, options?) => t('enum.country.ben.name', data, options),
  BES: (t, data?, options?) => t('enum.country.bes.name', data, options),
  BFA: (t, data?, options?) => t('enum.country.bfa.name', data, options),
  BGD: (t, data?, options?) => t('enum.country.bgd.name', data, options),
  BGR: (t, data?, options?) => t('enum.country.bgr.name', data, options),
  BHR: (t, data?, options?) => t('enum.country.bhr.name', data, options),
  BHS: (t, data?, options?) => t('enum.country.bhs.name', data, options),
  BIH: (t, data?, options?) => t('enum.country.bih.name', data, options),
  BLM: (t, data?, options?) => t('enum.country.blm.name', data, options),
  BLR: (t, data?, options?) => t('enum.country.blr.name', data, options),
  BLZ: (t, data?, options?) => t('enum.country.blz.name', data, options),
  BMU: (t, data?, options?) => t('enum.country.bmu.name', data, options),
  BOL: (t, data?, options?) => t('enum.country.bol.name', data, options),
  BRA: (t, data?, options?) => t('enum.country.bra.name', data, options),
  BRB: (t, data?, options?) => t('enum.country.brb.name', data, options),
  BRN: (t, data?, options?) => t('enum.country.brn.name', data, options),
  BTN: (t, data?, options?) => t('enum.country.btn.name', data, options),
  BVT: (t, data?, options?) => t('enum.country.bvt.name', data, options),
  BWA: (t, data?, options?) => t('enum.country.bwa.name', data, options),
  CAF: (t, data?, options?) => t('enum.country.caf.name', data, options),
  CAN: (t, data?, options?) => t('enum.country.can.name', data, options),
  CCK: (t, data?, options?) => t('enum.country.cck.name', data, options),
  CHE: (t, data?, options?) => t('enum.country.che.name', data, options),
  CHL: (t, data?, options?) => t('enum.country.chl.name', data, options),
  CHN: (t, data?, options?) => t('enum.country.chn.name', data, options),
  CIV: (t, data?, options?) => t('enum.country.civ.name', data, options),
  CMR: (t, data?, options?) => t('enum.country.cmr.name', data, options),
  COD: (t, data?, options?) => t('enum.country.cod.name', data, options),
  COG: (t, data?, options?) => t('enum.country.cog.name', data, options),
  COK: (t, data?, options?) => t('enum.country.cok.name', data, options),
  COL: (t, data?, options?) => t('enum.country.col.name', data, options),
  COM: (t, data?, options?) => t('enum.country.com.name', data, options),
  CPV: (t, data?, options?) => t('enum.country.cpv.name', data, options),
  CRI: (t, data?, options?) => t('enum.country.cri.name', data, options),
  CUB: (t, data?, options?) => t('enum.country.cub.name', data, options),
  CUW: (t, data?, options?) => t('enum.country.cuw.name', data, options),
  CXR: (t, data?, options?) => t('enum.country.cxr.name', data, options),
  CYM: (t, data?, options?) => t('enum.country.cym.name', data, options),
  CYP: (t, data?, options?) => t('enum.country.cyp.name', data, options),
  CZE: (t, data?, options?) => t('enum.country.cze.name', data, options),
  DEU: (t, data?, options?) => t('enum.country.deu.name', data, options),
  DJI: (t, data?, options?) => t('enum.country.dji.name', data, options),
  DMA: (t, data?, options?) => t('enum.country.dma.name', data, options),
  DNK: (t, data?, options?) => t('enum.country.dnk.name', data, options),
  DOM: (t, data?, options?) => t('enum.country.dom.name', data, options),
  DZA: (t, data?, options?) => t('enum.country.dza.name', data, options),
  ECU: (t, data?, options?) => t('enum.country.ecu.name', data, options),
  EGY: (t, data?, options?) => t('enum.country.egy.name', data, options),
  ERI: (t, data?, options?) => t('enum.country.eri.name', data, options),
  ESH: (t, data?, options?) => t('enum.country.esh.name', data, options),
  ESP: (t, data?, options?) => t('enum.country.esp.name', data, options),
  EST: (t, data?, options?) => t('enum.country.est.name', data, options),
  ETH: (t, data?, options?) => t('enum.country.eth.name', data, options),
  FIN: (t, data?, options?) => t('enum.country.fin.name', data, options),
  FJI: (t, data?, options?) => t('enum.country.fji.name', data, options),
  FLK: (t, data?, options?) => t('enum.country.flk.name', data, options),
  FRA: (t, data?, options?) => t('enum.country.fra.name', data, options),
  FRO: (t, data?, options?) => t('enum.country.fro.name', data, options),
  FSM: (t, data?, options?) => t('enum.country.fsm.name', data, options),
  GAB: (t, data?, options?) => t('enum.country.gab.name', data, options),
  GBR: (t, data?, options?) => t('enum.country.gbr.name', data, options),
  GEO: (t, data?, options?) => t('enum.country.geo.name', data, options),
  GGY: (t, data?, options?) => t('enum.country.ggy.name', data, options),
  GHA: (t, data?, options?) => t('enum.country.gha.name', data, options),
  GIB: (t, data?, options?) => t('enum.country.gib.name', data, options),
  GIN: (t, data?, options?) => t('enum.country.gin.name', data, options),
  GLP: (t, data?, options?) => t('enum.country.glp.name', data, options),
  GMB: (t, data?, options?) => t('enum.country.gmb.name', data, options),
  GNB: (t, data?, options?) => t('enum.country.gnb.name', data, options),
  GNQ: (t, data?, options?) => t('enum.country.gnq.name', data, options),
  GRC: (t, data?, options?) => t('enum.country.grc.name', data, options),
  GRD: (t, data?, options?) => t('enum.country.grd.name', data, options),
  GRL: (t, data?, options?) => t('enum.country.grl.name', data, options),
  GTM: (t, data?, options?) => t('enum.country.gtm.name', data, options),
  GUF: (t, data?, options?) => t('enum.country.guf.name', data, options),
  GUM: (t, data?, options?) => t('enum.country.gum.name', data, options),
  GUY: (t, data?, options?) => t('enum.country.guy.name', data, options),
  HKG: (t, data?, options?) => t('enum.country.hkg.name', data, options),
  HMD: (t, data?, options?) => t('enum.country.hmd.name', data, options),
  HND: (t, data?, options?) => t('enum.country.hnd.name', data, options),
  HRV: (t, data?, options?) => t('enum.country.hrv.name', data, options),
  HTI: (t, data?, options?) => t('enum.country.hti.name', data, options),
  HUN: (t, data?, options?) => t('enum.country.hun.name', data, options),
  IDN: (t, data?, options?) => t('enum.country.idn.name', data, options),
  IMN: (t, data?, options?) => t('enum.country.imn.name', data, options),
  IND: (t, data?, options?) => t('enum.country.ind.name', data, options),
  IOT: (t, data?, options?) => t('enum.country.iot.name', data, options),
  IRL: (t, data?, options?) => t('enum.country.irl.name', data, options),
  IRN: (t, data?, options?) => t('enum.country.irn.name', data, options),
  IRQ: (t, data?, options?) => t('enum.country.irq.name', data, options),
  ISL: (t, data?, options?) => t('enum.country.isl.name', data, options),
  ISR: (t, data?, options?) => t('enum.country.isr.name', data, options),
  ITA: (t, data?, options?) => t('enum.country.ita.name', data, options),
  JAM: (t, data?, options?) => t('enum.country.jam.name', data, options),
  JEY: (t, data?, options?) => t('enum.country.jey.name', data, options),
  JOR: (t, data?, options?) => t('enum.country.jor.name', data, options),
  JPN: (t, data?, options?) => t('enum.country.jpn.name', data, options),
  KAZ: (t, data?, options?) => t('enum.country.kaz.name', data, options),
  KEN: (t, data?, options?) => t('enum.country.ken.name', data, options),
  KGZ: (t, data?, options?) => t('enum.country.kgz.name', data, options),
  KHM: (t, data?, options?) => t('enum.country.khm.name', data, options),
  KIR: (t, data?, options?) => t('enum.country.kir.name', data, options),
  KNA: (t, data?, options?) => t('enum.country.kna.name', data, options),
  KOR: (t, data?, options?) => t('enum.country.kor.name', data, options),
  KWT: (t, data?, options?) => t('enum.country.kwt.name', data, options),
  LAO: (t, data?, options?) => t('enum.country.lao.name', data, options),
  LBN: (t, data?, options?) => t('enum.country.lbn.name', data, options),
  LBR: (t, data?, options?) => t('enum.country.lbr.name', data, options),
  LBY: (t, data?, options?) => t('enum.country.lby.name', data, options),
  LCA: (t, data?, options?) => t('enum.country.lca.name', data, options),
  LIE: (t, data?, options?) => t('enum.country.lie.name', data, options),
  LKA: (t, data?, options?) => t('enum.country.lka.name', data, options),
  LSO: (t, data?, options?) => t('enum.country.lso.name', data, options),
  LTU: (t, data?, options?) => t('enum.country.ltu.name', data, options),
  LUX: (t, data?, options?) => t('enum.country.lux.name', data, options),
  LVA: (t, data?, options?) => t('enum.country.lva.name', data, options),
  MAC: (t, data?, options?) => t('enum.country.mac.name', data, options),
  MAF: (t, data?, options?) => t('enum.country.maf.name', data, options),
  MAR: (t, data?, options?) => t('enum.country.mar.name', data, options),
  MCO: (t, data?, options?) => t('enum.country.mco.name', data, options),
  MDA: (t, data?, options?) => t('enum.country.mda.name', data, options),
  MDG: (t, data?, options?) => t('enum.country.mdg.name', data, options),
  MDV: (t, data?, options?) => t('enum.country.mdv.name', data, options),
  MEX: (t, data?, options?) => t('enum.country.mex.name', data, options),
  MHL: (t, data?, options?) => t('enum.country.mhl.name', data, options),
  MKD: (t, data?, options?) => t('enum.country.mkd.name', data, options),
  MLI: (t, data?, options?) => t('enum.country.mli.name', data, options),
  MLT: (t, data?, options?) => t('enum.country.mlt.name', data, options),
  MMR: (t, data?, options?) => t('enum.country.mmr.name', data, options),
  MNE: (t, data?, options?) => t('enum.country.mne.name', data, options),
  MNG: (t, data?, options?) => t('enum.country.mng.name', data, options),
  MNP: (t, data?, options?) => t('enum.country.mnp.name', data, options),
  MOZ: (t, data?, options?) => t('enum.country.moz.name', data, options),
  MRT: (t, data?, options?) => t('enum.country.mrt.name', data, options),
  MSR: (t, data?, options?) => t('enum.country.msr.name', data, options),
  MTQ: (t, data?, options?) => t('enum.country.mtq.name', data, options),
  MUS: (t, data?, options?) => t('enum.country.mus.name', data, options),
  MWI: (t, data?, options?) => t('enum.country.mwi.name', data, options),
  MYS: (t, data?, options?) => t('enum.country.mys.name', data, options),
  MYT: (t, data?, options?) => t('enum.country.myt.name', data, options),
  NAM: (t, data?, options?) => t('enum.country.nam.name', data, options),
  NCL: (t, data?, options?) => t('enum.country.ncl.name', data, options),
  NER: (t, data?, options?) => t('enum.country.ner.name', data, options),
  NFK: (t, data?, options?) => t('enum.country.nfk.name', data, options),
  NGA: (t, data?, options?) => t('enum.country.nga.name', data, options),
  NIC: (t, data?, options?) => t('enum.country.nic.name', data, options),
  NIU: (t, data?, options?) => t('enum.country.niu.name', data, options),
  NLD: (t, data?, options?) => t('enum.country.nld.name', data, options),
  NOR: (t, data?, options?) => t('enum.country.nor.name', data, options),
  NPL: (t, data?, options?) => t('enum.country.npl.name', data, options),
  NRU: (t, data?, options?) => t('enum.country.nru.name', data, options),
  NZL: (t, data?, options?) => t('enum.country.nzl.name', data, options),
  OMN: (t, data?, options?) => t('enum.country.omn.name', data, options),
  PAK: (t, data?, options?) => t('enum.country.pak.name', data, options),
  PAN: (t, data?, options?) => t('enum.country.pan.name', data, options),
  PCN: (t, data?, options?) => t('enum.country.pcn.name', data, options),
  PER: (t, data?, options?) => t('enum.country.per.name', data, options),
  PHL: (t, data?, options?) => t('enum.country.phl.name', data, options),
  PLW: (t, data?, options?) => t('enum.country.plw.name', data, options),
  PNG: (t, data?, options?) => t('enum.country.png.name', data, options),
  POL: (t, data?, options?) => t('enum.country.pol.name', data, options),
  PRI: (t, data?, options?) => t('enum.country.pri.name', data, options),
  PRK: (t, data?, options?) => t('enum.country.prk.name', data, options),
  PRT: (t, data?, options?) => t('enum.country.prt.name', data, options),
  PRY: (t, data?, options?) => t('enum.country.pry.name', data, options),
  PSE: (t, data?, options?) => t('enum.country.pse.name', data, options),
  PYF: (t, data?, options?) => t('enum.country.pyf.name', data, options),
  QAT: (t, data?, options?) => t('enum.country.qat.name', data, options),
  REU: (t, data?, options?) => t('enum.country.reu.name', data, options),
  ROU: (t, data?, options?) => t('enum.country.rou.name', data, options),
  RUS: (t, data?, options?) => t('enum.country.rus.name', data, options),
  RWA: (t, data?, options?) => t('enum.country.rwa.name', data, options),
  SAU: (t, data?, options?) => t('enum.country.sau.name', data, options),
  SDN: (t, data?, options?) => t('enum.country.sdn.name', data, options),
  SEN: (t, data?, options?) => t('enum.country.sen.name', data, options),
  SGP: (t, data?, options?) => t('enum.country.sgp.name', data, options),
  SGS: (t, data?, options?) => t('enum.country.sgs.name', data, options),
  SHN: (t, data?, options?) => t('enum.country.shn.name', data, options),
  SJM: (t, data?, options?) => t('enum.country.sjm.name', data, options),
  SLB: (t, data?, options?) => t('enum.country.slb.name', data, options),
  SLE: (t, data?, options?) => t('enum.country.sle.name', data, options),
  SLV: (t, data?, options?) => t('enum.country.slv.name', data, options),
  SMR: (t, data?, options?) => t('enum.country.smr.name', data, options),
  SOM: (t, data?, options?) => t('enum.country.som.name', data, options),
  SPM: (t, data?, options?) => t('enum.country.spm.name', data, options),
  SRB: (t, data?, options?) => t('enum.country.srb.name', data, options),
  SSD: (t, data?, options?) => t('enum.country.ssd.name', data, options),
  STP: (t, data?, options?) => t('enum.country.stp.name', data, options),
  SUR: (t, data?, options?) => t('enum.country.sur.name', data, options),
  SVK: (t, data?, options?) => t('enum.country.svk.name', data, options),
  SVN: (t, data?, options?) => t('enum.country.svn.name', data, options),
  SWE: (t, data?, options?) => t('enum.country.swe.name', data, options),
  SWZ: (t, data?, options?) => t('enum.country.swz.name', data, options),
  SXM: (t, data?, options?) => t('enum.country.sxm.name', data, options),
  SYC: (t, data?, options?) => t('enum.country.syc.name', data, options),
  SYR: (t, data?, options?) => t('enum.country.syr.name', data, options),
  TCA: (t, data?, options?) => t('enum.country.tca.name', data, options),
  TCD: (t, data?, options?) => t('enum.country.tcd.name', data, options),
  TGO: (t, data?, options?) => t('enum.country.tgo.name', data, options),
  THA: (t, data?, options?) => t('enum.country.tha.name', data, options),
  TJK: (t, data?, options?) => t('enum.country.tjk.name', data, options),
  TKL: (t, data?, options?) => t('enum.country.tkl.name', data, options),
  TKM: (t, data?, options?) => t('enum.country.tkm.name', data, options),
  TLS: (t, data?, options?) => t('enum.country.tls.name', data, options),
  TON: (t, data?, options?) => t('enum.country.ton.name', data, options),
  TTO: (t, data?, options?) => t('enum.country.tto.name', data, options),
  TUN: (t, data?, options?) => t('enum.country.tun.name', data, options),
  TUR: (t, data?, options?) => t('enum.country.tur.name', data, options),
  TUV: (t, data?, options?) => t('enum.country.tuv.name', data, options),
  TWN: (t, data?, options?) => t('enum.country.twn.name', data, options),
  TZA: (t, data?, options?) => t('enum.country.tza.name', data, options),
  UGA: (t, data?, options?) => t('enum.country.uga.name', data, options),
  UKR: (t, data?, options?) => t('enum.country.ukr.name', data, options),
  UMI: (t, data?, options?) => t('enum.country.umi.name', data, options),
  URY: (t, data?, options?) => t('enum.country.ury.name', data, options),
  USA: (t, data?, options?) => t('enum.country.usa.name', data, options),
  UZB: (t, data?, options?) => t('enum.country.uzb.name', data, options),
  VAT: (t, data?, options?) => t('enum.country.vat.name', data, options),
  VCT: (t, data?, options?) => t('enum.country.vct.name', data, options),
  VEN: (t, data?, options?) => t('enum.country.ven.name', data, options),
  VGB: (t, data?, options?) => t('enum.country.vgb.name', data, options),
  VIR: (t, data?, options?) => t('enum.country.vir.name', data, options),
  VNM: (t, data?, options?) => t('enum.country.vnm.name', data, options),
  VUT: (t, data?, options?) => t('enum.country.vut.name', data, options),
  WLF: (t, data?, options?) => t('enum.country.wlf.name', data, options),
  WSM: (t, data?, options?) => t('enum.country.wsm.name', data, options),
  XKX: (t, data?, options?) => t('enum.country.xkx.name', data, options),
  YEM: (t, data?, options?) => t('enum.country.yem.name', data, options),
  ZAF: (t, data?, options?) => t('enum.country.zaf.name', data, options),
  ZMB: (t, data?, options?) => t('enum.country.zmb.name', data, options),
  ZWE: (t, data?, options?) => t('enum.country.zwe.name', data, options),
  /* eslint-enable max-len */
};
